module.exports = __webpack_public_path__ + "ff92cb44e3658c11f9e6d9691f789b6f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/icons/dashboard.png
// module id = 1101
// module chunks = 0